import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class GoalsTableOwnerSelectorComponent extends DropdownActivator {
  @tracked personFormIsVisible = false;
  @tracked teamFormIsVisible = false;
  @tracked departmentFormIsVisible = false;
  selectedGoal = null;

  get goal() {
    return this.args.goal;
  }

  @action
  handleOwnerSelect(goal, item) {
    if (item.id === 'clear') {
      goal.owner = null;
    } else {
      goal.owner = item;
    }
    goal.save();
  }

  @action
  togglePersonForm(goal, val) {
    if (goal) this.selectedGoal = goal;
    else this.selectedGoal = null;
    if (val !== undefined) this.personFormIsVisible = val;
    else this.personFormIsVisible = !this.personFormIsVisible;
  }

  @action
  toggleTeamForm(goal, val) {
    if (goal) this.selectedGoal = goal;
    else this.selectedGoal = null;
    if (val !== undefined) this.teamFormIsVisible = val;
    else this.teamFormIsVisible = !this.teamFormIsVisible;
  }

  @action
  async onPersonAdded(person) {
    this.selectedGoal.owner = person;
    await this.selectedGoal.save();
  }

  @action
  async onTeamAdded(team) {
    this.selectedGoal.owner = team;
    await this.selectedGoal.save();
  }

  @action
  toggleDepartmentForm(goal, val) {
    if (goal) this.selectedGoal = goal;
    else this.selectedGoal = null;
    if (val !== undefined) this.departmentFormIsVisible = val;
    else this.departmentFormIsVisible = !this.departmentFormIsVisible;
  }

  @action
  async onDepartmentAdded(department) {
    this.selectedGoal.owner = department;
    await this.selectedGoal.save();
  }
}
